<template>
  <div id="app" ref="app">
    <header-box></header-box>
    <transition
      name="bounce"
      enter-active-class="bounceInUp"
      leave-active-class="bounceOutDowm"
    >
      <router-view />
    </transition>
    <footerBox></footerBox>
    <div class="anchor-box" v-show="scrollShow">
      <div class="top-anchor pointer" @click="contactShowClick">
        <img
          class="top-anchor-img text-color-fff"
          src="./assets/images/index/contact.svg"
          fill="#fff"
          alt=""
        />
        <div class="contant-box flex-center text-color-fff">
          {{ $t("localization.homeFont4") }}
        </div>
      </div>
      <!-- <div
        class="go-top flex-center pointer pc"
        @mouseover="schemeErOver"
        @mouseout="schemeErOut"
      >
        <img class="go-top-img " src="./assets/images/index/er.svg" alt="" />
      </div> -->
      <el-popover placement="top-start" trigger="hover">
        <div class="sweep-box flex-center">
          <img class="sweep-img" src="./assets/images/index/sweep.png" alt="" />
          <div
            class="flex-center text-color2"
            style="font-size: 14px; margin-top: 6px;"
          >
            扫一扫
          </div>
        </div>

        <div class="go-top flex-center pointer pc " slot="reference">
          <img class="go-top-img " src="./assets/images/index/er.svg" alt="" />
        </div>
      </el-popover>
      <div class="go-top flex-center pointer" @click="goTop">
        <img
          class="go-top-img "
          src="./assets/images/index/go-top.svg"
          alt=""
        />
      </div>
    </div>
    <consultPop
      :centerDialogVisible="contactShow"
      @cancelHide="cancelHide"
    ></consultPop>
  </div>
</template>

<script>
import headerBox from "./components/common/header.vue";
import footerBox from "./components/common/footer-box.vue";
import consultPop from "./components/common/consult-pop.vue";
import { getClassify } from "@/api/index.js";
import router from "@/router";
export default {
  name: "App",
  data() {
    return {
      scrollShow: false,
      contactShow: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollTop);
    getClassify({ classifyType: "0", language: "zh" }).then(res => {
      if (res.code == 0) {
        if (res.data.length > 0) {
          let data = [{ path: "/succeedCase/AllCase" }];
          res.data[0].children.forEach(item => {
            data.push({
              path: "/succeedCase/" + item.outLink,
              component: () => import("@/views/case-box.vue")
            });
          });
          let obj = {
            path: `/succeedCase`, //成功案例
            redirect: "/succeedCase/AllCase",
            component: () => import("@/views/succeed-case.vue"),
            meta: { scrollTrue: true },
            children: data
          };
          router.addRoutes([obj]);
        }
      }
    });
  },
  components: {
    headerBox,
    footerBox,
    consultPop
  },
  methods: {
    schemeErOver() {},
    schemeErOut() {},
    handleScrollTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      // console.log(this.$children)
      if (scrollTop > 400) {
        this.scrollShow = true;
      } else {
        this.scrollShow = false;
      }
    },
    goTop() {
      let timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 100;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
    contactShowClick() {
      this.contactShow = true;
    },
    cancelHide() {
      this.contactShow = false;
    }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
.sweep-box {
  flex-direction: column;
}
.sweep-img {
  width: 80px;
  height: 80px;
}
.anchor-box {
  width: 64px;
  height: 232px;
  position: fixed;
  right: 60px;
  bottom: 70px;
  z-index: 999;
  .top-anchor {
    width: 100%;
    height: 92px;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: #c7000a;
    box-shadow: 0px 8px 20px 0px rgba(158, 164, 180, 0.25);
    .top-anchor-img {
      width: 34px;
      height: 34px;
    }
    .contant-box {
      width: 100%;
      height: 30px;
      font-size: 14px;
    }
  }
  .go-top {
    width: 100%;
    height: 60px;
    margin-top: 10px;
    background: #c7000a;
    box-shadow: 0px 8px 20px 0px rgba(158, 164, 180, 0.25);
    position: relative;
    .go-top-img {
      width: 36px;
      height: 36px;
    }
  }
}
@media screen and (max-width: 767px) {
  .anchor-box {
    right: 30px;
    bottom: 50px;
    width: 44px;
    height: 130px;
    .top-anchor {
      height: 66px;
      .top-anchor-img {
        width: 24px;
        height: 24px;
      }
      .contant-box {
        font-size: 12px;
      }
    }
    .go-top {
      width: 100%;
      height: 42px;
      .go-top-img {
        width: 26px;
        height: 26px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue